<template>
  <div class="intro_parallax">
    <div class="items">
      <div class="item rect_blue" data-parallax="3">
        <img :src="require('@/assets/img/parallax/rect_blue_left.png')" />
      </div>
      <div class="item rect_red" data-parallax="5">
        <img :src="require('@/assets/img/parallax/rect_red_left.png')" />
      </div>
      <div class="item circle" data-parallax="25">
        <img :src="require('@/assets/img/parallax/circle_red_center.png')" />
      </div>
      <div class="item circle_blue" data-parallax="25">
        <img :src="require('@/assets/img/parallax/circle_blue_left.png')" />
      </div>
      <div class="item circle2" data-parallax="30">
        <img :src="require('@/assets/img/parallax/circle_red_2_right.png')" />
      </div>
      <div class="item circle3" data-parallax="15">
        <img :src="require('@/assets/img/parallax/circle_red_right.png')" />
      </div>
      <div class="item rect_long" data-parallax="4">
        <img :src="require('@/assets/img/parallax/rect_gray_right.png')" />
      </div>
      <div class="item rect_blue2" data-parallax="5">
        <img :src="require('@/assets/img/parallax/rect_blue_right.png')" />
      </div>
      <div class="item line1" data-parallax="8">
        <div class="line"></div>
      </div>
      <div class="item line2" data-parallax="8">
        <div class="line"></div>
      </div>
      <div class="item line3" data-parallax="8">
        <div class="line"></div>
      </div>
      <div class="item line4" data-parallax="8">
        <div class="line"></div>
      </div>
      <div class="item line5" data-parallax="8">
        <div class="line"></div>
      </div>
      <div class="item line6" data-parallax="8">
        <div class="line"></div>
      </div>
      <div class="item line7" data-parallax="8">
        <div class="line"></div>
      </div>
      <div class="item line8" data-parallax="8">
        <div class="line"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IntroParallax",
  props: ["stop"],
  computed: {
    isMobileDevice() {
      return this.$store.state.isMobileDevice;
    },
  },
  methods: {
    initParallax() {
      let items = document.querySelectorAll("[data-parallax]");
      document.documentElement.addEventListener("mousemove", (e) => {
        if (this.stop) return;
        let w = window.innerWidth;
        let h = window.innerHeight;

        let offsetX = 0.5 - e.pageX / w;
        let offsetY = 0.5 - e.pageY / h;

        items.forEach((el) => {
          let k = el.dataset.parallax; // коэффициент сдвига
          el.style.transform =
            "translate3d(" + offsetX * k + "%," + offsetY * k + "%,0)";
        });
      });
    },
  },
  mounted() {
    if (!this.isMobileDevice) {
      this.initParallax();
    }
  },
};
</script>

<style scoped lang="scss">

.intro_parallax {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden;
  z-index: -1;
}
.items {
  .item {
    position: absolute;
    transform-style: preserve-3d;
    &.rect_blue {
      top: 11%;
      left: -6%;
      width: 11vw;
      img {
        animation-delay: -1s;
      }
    }
    &.rect_red {
      bottom: 11%;
      left: -2%;
      width: 9vw;
      img {
        animation-delay: -2s;
      }
    }
    &.circle {
      top: 7.5%;
      left: 24%;
      width: 2.3vw;
      img {
        animation-delay: -8s;
      }
    }

    &.circle_blue {
      top: 54%;
      left: 4.5%;
      width: 1.4vw;
      img {
        animation-delay: -5s;
      }
    }
    &.circle2 {
      top: 19.5%;
      right: 16.2%;
      width: 3.4vw;
      img {
        animation-delay: -4s;
      }
    }
    &.rect_blue2 {
      bottom: 16%;
      right: -2.5%;
      width: 8.58vw;
      img {
        animation-delay: -6s;
      }
    }
    &.circle3 {
      bottom: 28.3%;
      right: 4%;
      width: 2.5vw;
      img {
        animation-delay: -8s;
      }
    }
    &.rect_long {
      top: 4.9%;
      right: 8.2%;
      width: 5.4vw;
      img {
        animation-delay: -4s;
      }
    }
  }
  img {
    width: 100%;
    animation: move 10s infinite;
    will-change: transform;
  }
  .item {
    .line {
      height: 2px;
      animation: move_line 45s infinite;
      outline: 1px solid transparent;
      opacity: 0.8;
    }
    &.line1 {
      top: 33.5%;
      left: 7.5%;
      transform: rotate(-57deg);
      .line {
        width: 8vw;
        background: #bebebe;
        animation-delay: -20s;
      }
    }
    &.line2 {
      top: 27.5%;
      left: 18.5%;
      .line {
        width: 5vw;
        background: #026fd1;
        animation-delay: -15s;
      }
    }
    &.line3 {
      top: 15.5%;
      left: 30.8%;
      .line {
        width: 7.5vw;
        background: #06c5e9;
        animation-delay: -4s;
      }
    }
    &.line4 {
      top: 14.5%;
      left: 47%;
      .line {
        width: 7.5vw;
        background: #06c5e9;
        animation-delay: -32s;
      }
    }
    &.line5 {
      top: 30.8%;
      right: 3.6%;
      .line {
        width: 7vw;
        background: #06c5e9;
        animation-delay: -27s;
      }
    }
    &.line6 {
      top: 49%;
      right: -2%;
      .line {
        width: 8vw;
        background: #fb1f03;
        animation-delay: -11s;
      }
    }
    &.line7 {
      bottom: 15%;
      right: 3.5%;
      .line {
        width: 7.5vw;
        background: #06c5e9;
        animation-delay: -10s;
      }
    }
    &.line8 {
      bottom: 20%;
      left: 51.5%;
      .line {
        width: 7.5vw;
        background: #fb1f03;
        animation-delay: -35s;
      }
    }
  }
  &.stop {
    img,
    .line {
      animation-play-state: paused;
    }
  }
}
@keyframes move_line {
  0% {
    transform: translate3d(0, 0, 0px) rotate(0);
  }
  33% {
    transform: translate3d(-10px, -10px, 25px) rotate(-45deg);
  }
  66% {
    transform: translate3d(10px, 10px, 50px) rotate(45deg);
  }
  100% {
    transform: translate3d(0, 0, 0px) rotate(0);
  }
}
@keyframes move {
  0% {
    transform: translate3d(0, 0, 0px);
  }
  33% {
    transform: translate3d(-10px, -10px, 25px);
  }
  66% {
    transform: translate3d(10px, 10px, 50px);
  }
  100% {
    transform: translate3d(0, 0, 0px);
  }
}
.mobile .intro_parallax {
  .item {
    &.rect_blue {
      display: none;
    }
    &.rect_red {
      bottom: 2%;
      left: 4%;
      width: 20vw;
      transform: rotate(90deg) scale(1, -1);
    }
    &.circle {
      top: 20%;
      left: 2%;
      width: 8.3vw;
      opacity: 0.8;
    }

    &.circle_blue {
      top: initial;
      bottom: 8%;
      left: 38%;
      width: 4.4vw;
    }
    &.circle2 {
      top: 9.5%;
      right: 27.5%;
      width: 6.4vw;
    }
    &.rect_blue2 {
      bottom: 4%;
      right: 4.5%;
      width: 21vw;
      transform: rotate(61deg) scale(1, -1);
    }
    &.circle3 {
      bottom: 30.3%;
      right: 2%;
      width: 7.5vw;
    }
    &.rect_long {
      top: 16.9%;
      right: 2.2%;
      width: 14.4vw;
      transform: rotate(-30deg);
    }

    &.line1 {
      top: initial;
      bottom: 22%;
      left: 32.5%;
      .line {
        width: 20vw;
      }
    }
    &.line2 {
      top: initial;
      left: -3%;
      bottom: 26%;
      .line {
        width: 20vw;
      }
    }
    &.line3 {
      top: 11.5%;
      left: 10.8%;
      .line {
        width: 20vw;
        height: 1vw;
        opacity: 0.5;
      }
    }
    &.line4 {
      top: 13.5%;
      left: 77%;
      .line {
        width: 20vw;
        height: 1vw;
        opacity: 0.5;
      }
    }
    &.line5 {
      top: 44.8%;
      .line {
        width: 20vw;
        height: 1vw;
        opacity: 0.5;
      }
    }
    &.line6 {
      top: 10%;
      right: 38%;
      .line {
        width: 20vw;
        height: 1vw;
        opacity: 0.5;
      }
    }
    &.line7 {
      bottom: 28%;
      right: 21%;
      .line {
        width: 12vw;
      }
    }
    &.line8 {
      bottom: 55%;
      left: 0;
      .line {
        width: 20vw;
      }
    }
  }
}
</style>
